import { CONTAINER_NAME } from "../_utils/constant";
import { normalize } from "../common";
var vibrateShort = normalize(function (_ref) {
  var type = _ref.type,
      success = _ref.success,
      fail = _ref.fail,
      complete = _ref.complete;
  wx.vibrateShort({
    type: type,
    success: success,
    fail: fail,
    complete: complete
  });
}, CONTAINER_NAME.WECHAT);
export default vibrateShort;